/**
 * DOM を引くときの小さなヘルパー。
 *
 * `document.getElementById()` はどの要素も HTMLElement として返すため、
 * input の `value` やボタンの `disabled` を触るたびに型が合わなくなる。
 * 取得する側で要素の種類を1回だけ指定できるようにして、
 * 呼び出しごとのキャストをなくす。
 */

/** id で要素を引く。種類は呼び出し側が指定する（既定は HTMLElement） */
export function byId<T extends HTMLElement = HTMLElement>(id: string): T | null {
  return document.getElementById(id) as T | null;
}

/** セレクタで1つ引く */
export function query<T extends Element = HTMLElement>(selector: string, root: ParentNode = document): T | null {
  return root.querySelector<T>(selector);
}

/** セレクタで全部引く。NodeList ではなく配列で返す */
export function queryAll<T extends Element = HTMLElement>(selector: string, root: ParentNode = document): T[] {
  return Array.from(root.querySelectorAll<T>(selector));
}

/** イベントの発生元から、条件に合う祖先要素を探す */
export function closestFrom<T extends Element = HTMLElement>(target: EventTarget | null, selector: string): T | null {
  return target instanceof Element ? target.closest<T>(selector) : null;
}

/**
 * 選択範囲の基準ノードから、それを含む要素を得る。
 * テキストノードには closest() が無いため、親要素に読み替える。
 */
export function containingElement(node: Node | null): Element | null {
  if (!node) {
    return null;
  }
  return node.nodeType === Node.ELEMENT_NODE ? (node as Element) : node.parentElement;
}
